import { render, staticRenderFns } from "./industryInfo.vue?vue&type=template&id=f4c9e2fa&scoped=true"
import script from "./industryInfo.vue?vue&type=script&lang=js"
export * from "./industryInfo.vue?vue&type=script&lang=js"
import style0 from "./industryInfo.vue?vue&type=style&index=0&id=f4c9e2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c9e2fa",
  null
  
)

export default component.exports